let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("laeSv")).then(() => parcelRequire('1lA3p'));